<template>
  <div>
    <v-dialog
      :value="true"
      persistent
      :width="hideOptions ? 600 : 1000"
    >
      <v-card>
        <v-toolbar
          dense
          dark
          flat
          class="primary-color"
        >
          {{title}}
        </v-toolbar>
        <v-card-text>
          <v-form
            ref="idValidation"
          >
            <v-layout wrap>
              <v-flex
                :sm6="!hideOptions"
                style="padding:5px"
              >
                <slot>
                  <v-textarea
                    v-model="updateIds"
                    :disabled="saving"
                    :rules="rules"
                    outline
                    label="IDs to Update"
                    rows="15"
                    no-resize
                  />
                </slot>
              </v-flex>
              <v-flex
                v-if="!hideOptions"
                sm6
                style="padding: 5px 15px 25px 15px;"
              >
                <div
                  v-for="field in actions"
                  :key="field.prop"
                  v-show="!field.advanced || showAdvanced"
                >
                  <div
                    v-if="field.type == 'dropdown'"
                  >
                    <v-select
                      v-if="visible(field)"
                      v-model="field.value"
                      :items="field.options"
                      :hint="field.hint"
                      :disabled="saving"
                      :rules="requirementCheck(field)"
                      item-text="name"
                      item-value="value"
                      item-disabled="apionly"
                      :label="field.title"
                      flat
                      persistent-hint
                    >
                      <template slot="item" slot-scope="data">
                        <div>
                          <v-icon
                            v-if="data.item.icon"
                            left
                          >
                            {{data.item.icon}}
                          </v-icon>
                          {{data.item.name}}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div
                    v-if="field.type == 'tags'"
                  >
                    <v-combobox
                      v-if="visible(field)"
                      v-model="field.value"
                      :items="field.results"
                      :search-input.sync="field.search"
                      :label="field.title"
                      :hint="field.hint"
                      :disabled="saving"
                      :rules="requirementCheck(field)"
                      multiple
                      item-text="tag"
                      item-value="tag"
                      :return-object="false"
                      flat
                      small-chips
                      persistent-hint
                      hide-selected
                      auto-select-first
                      @focus="tagFocused = field"
                      @input="field.search = ''"
                    />
                  </div>
                  <div
                    v-if="field.type == 'selection'"
                  >
                    <v-combobox
                      v-if="visible(field)"
                      v-model="field.value"
                      :items="field.results"
                      item-text="name"
                      item-value="value"
                      :search-input.sync="field.search"
                      :label="field.title"
                      :hint="field.hint"
                      :disabled="saving"
                      :rules="requirementCheck(field)"
                      flat
                      persistent-hint
                      auto-select-first
                      hide-selected
                      @focus="tagFocused = field"
                      @input="field.search = ''"
                    />
                  </div>
                  <div
                    v-if="field.type == 'checkbox'"
                  >
                    <v-checkbox
                      v-if="visible(field)"
                      v-model="field.value"
                      item-text="name"
                      item-value="value"
                      :rules="requirementCheck(field)"
                      :label="field.title"
                      :hint="field.hint"
                      :disabled="saving"
                      flat
                      persistent-hint
                    />
                  </div>
                  <div
                    v-if="field.type == 'header'"
                    style="margin-top: 15px;border-bottom: 1px solid #262626;"
                  >
                    <span
                      style="font-size: 18px;font-weight: bold;"
                    >
                      {{field.title}}
                    </span>
                    <span
                      v-if="field.subtitle"
                      style="font-size: 12px;"
                    >
                      <br />{{field.subtitle}}
                    </span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-switch
            style="padding-left: 20px;"
            v-if="!hideOptions && actions.filter(obj => obj.advanced).length > 0"
            v-model="showAdvanced"
            flat
            label="Advanced Options"
          />
          <v-spacer />
          <v-btn
            :disabled="saving"
            flat
            @click="$emit('cancel')"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="disableRunTask"
            color="primary"
            @click="save()"
          >
            Run Task
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="destructiveDialog"
      persistent
      width="400"
    >
      <v-card
        style="background: #F44336; color: white;"
      >
        <v-card-text
          style="text-align:center"
        >
          <v-icon
            color="white"
            size="92"
          >
            mdi-alert-octagon
          </v-icon><br />
          <span
            style="font-size: 18px;color:white;font-weight:bold"
          >
            WARNING
          </span>
          <br />This operation will be destructive, and may result in data loss if used improperly. Continue at your own risk.
        </v-card-text>
        <v-card-actions>
          <v-btn
            dark
            small
            flat
            @click="save(true);destructiveDialog = false"
          >
            Continue with Destructive Action
          </v-btn>
          <v-spacer />
          <v-btn
            color="white"
            @click="destructiveDialog = false;saving = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'

export default {
  name: 'BulkOpsDialog',
  props: ['title', 'update_actions', 'disabled', 'hideOptions'],
  data () {
    return {
      tagResults: [],
      tagFocused: {},
      tagSearch: null,
      showAdvanced: false,
      updateIds: '',
      actions: JSON.parse(JSON.stringify(this.update_actions)),
      saving: false,
      destructiveDialog: false,
      rules: [
        value => !!value || 'Required',
        value => {
          const pattern = /[^\d\s]/
          return !pattern.test(value) || 'Only Digits are accepted inputs for IDs'
        },
      ],
      canPost: false
    }
  },
  computed: {
    disableRunTask () {
      return this.saving || this.canPost || this.disabled
    }
  },
  watch: {
    tagFocused: {
      deep: true,
      handler () {
        if (this.tagFocused) {
          if (this.tagFocused.search) {
            this.fetchTags(this.tagFocused)
          }
        }
      }
    },
    updateIds () {
      this.canPost = !this.$refs.idValidation.validate()   
    }
  },
  methods: {
    fetchTags (field) {
      if (field.search.length < 3)
        return
      var searchText = field.search
      if (field.type_scope == "userform") {
        api.userform.userformTags.get(searchText)
          .then(tagResults => {
            field.results = tagResults
            this.$forceUpdate()
          })
      } else if (field.type_scope == "contact") {
        api.userform.contactTags.get(searchText)
          .then(tagResults => {
            field.results = tagResults
            this.$forceUpdate()
          })
      } else if (field.type_scope == "templates") {
        api.formtemplate.formtemplate.list({
          search: searchText
        })
          .then(data => {
            var searchArray = []
            data.results.forEach(form => {
              searchArray.push({
                "name": form['name'],
                "value": form['id']
              })
            })
            field.results = searchArray
            this.$forceUpdate()
          })
      } else if (field.type_scope == "casetypes") {
        api.cases.casetype.list({
          search: searchText
        })
          .then(data => {
            field.results = data.results.map(item => { return { "name": item['name'], "value": item['id'] } });
            this.$forceUpdate();
          });
      }
    },
    requirementCheck(field) {
      if (field.required)
        return [value => value !== null || 'Required']
      if (field.cond_req_prop) {
        var check_prop = this.actions.filter(f => f.prop == field.cond_req_prop)
        if (check_prop.length == 1) {
          if (check_prop[0].value == field.cond_req_value)
            return [value => value !== null || 'Required due to ' + check_prop[0].title]
        }
      }
      return []
    },
    save (skipCheck = false) {
      if (this.$refs.idValidation.validate()) {
        this.saving = true
        var destructive = false
        this.actions.forEach((prop) => {
          if (!!prop.destructive && prop.value) {
            destructive = true
          }
        })
        var saveVariable = {
          "update": this.updateIds.replace(" ", ""),
          "props": this.actions
        }
        if (destructive && !skipCheck) {
          this.destructiveDialog = true 
          return
        }
        this.$emit('save', saveVariable)     
      }
    },
    visible (prop) {
      if (prop.prereq) {
        return this.actions.find(x => x.prop === prop.prereq).value == true
      }
      return true
    }
  }
}
</script>
